import PropTypes from 'prop-types';
import type { FC, ReactNode } from 'react';
import { createContext, useState } from 'react';
import { Recipient, RecipientSearchParam } from '../types/user';


interface GlobalStates {
  emergencyOpened: boolean
  myCount: number
  emergencyPopupEnabled: boolean
  hCenterMap: object
  // for silverList
  silverList: Recipient[]
  silverSearchParam: RecipientSearchParam
  silverLimit: number
  silverTotalPage: number
  // 지자체
}

interface MyAppContextValue {
  // emergencyCallOpened: boolean
  // setEmergencyCallOpened: (opened: boolean) => void
  states: GlobalStates
  setStates: (arg: GlobalStates) => void
}

const initialStates: GlobalStates = {
  emergencyOpened: false,
  myCount: 1,
  emergencyPopupEnabled: true,
  hCenterMap: null,
  silverList: [],
  silverSearchParam: {
    from_date: '',
    end_date: '',
    del_from_date: '',
    del_end_date: '',
    search_item: '',
    search_content: '',
    op: '',
    notify_type: '',
    area: null,
    sigungu: '',
    user_id: '',
    simpleSelect: '',
    simpleRadio: '',
    req_type: '',
    page: 0,
    per_page: 50
  },
  silverLimit: 50,
  silverTotalPage: 0,
}

const MyAppContext = createContext<MyAppContextValue>({
  // emergencyCallOpened: false,
  // setEmergencyCallOpened: () => {},
  states: initialStates,
  setStates: (arg) => {}
})

interface MyAppProps {
  children: ReactNode
}

export const MyAppProvider: FC<MyAppProps> = (props) => {
  const {children} = props
  const [opened, setOpened] = useState(false)
  const [states, setStates] = useState<GlobalStates>(initialStates)

  const funcSetOpened = (arg: boolean): void => {
    setOpened(arg)
  }

  const funcSetStates = (arg: GlobalStates): void => {
    // console.log('funcSetStates: ', arg)
    setStates(arg)
  }

  return (
    <MyAppContext.Provider value={{
      // emergencyCallOpened: opened,
      // setEmergencyCallOpened: funcSetOpened,
      states,
      setStates: funcSetStates
    }}
    >
      {children}
    </MyAppContext.Provider>
  )
}

MyAppProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export default MyAppContext
